export default __webpack_public_path__ + "static/media/IMG_1859.42a896ac.jpg";